<template>
<div class="mt-4">
  <div >
    <div class="d-flex align-start review mb-2" v-for="review in productReviews" :key="review.id"> 
    <div class="mr-6">
      <img :src="review.avatar" alt="" srcset="" />
            <!-- <img :src="product.images[0].imageUrl" alt="" srcset="" /> -->

    </div>
    <div class="mt-2">
      <div class="user-name">{{ review.leftBy}}</div>
      <div class="post-date">{{ review.createdAt | relativeCreationDate }}</div>
      <div class="review-description">{{ review.comment }}</div>
      <div class="d-flex align-center">
        <v-rating
          readonly
          dense
          class="pl-0 product-rating mr-2"
          v-model="review.rating"
          color="appOrange"
          background-color="#d3d3d3"
        ></v-rating>
        {{ review.rating }}
      </div>
    </div>
    </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

import moment from 'moment-timezone';

export default {
  props: ['productImages'],
  filters: {
    relativeCreationDate: function (date) {
      return moment.utc(date).fromNow();
   }
  },
  data() {
    return {
      rating: 3.1
    };
  },
  computed: {
    ...mapState({
      productReviews: state => state.product.productReviews,
      product: state => state.product.product,
    }),
  }
};
</script>
<style scoped lang="scss" src="./Review.scss"></style>
